/**
 * Shim for Node 'os' module so Coil/Okio work in browser.
 * Okio JsPlatform calls os.tmpdir(); webpack fallback was false, causing "tmpdir is not a function".
 */
module.exports = {
  tmpdir: function () {
    return '/';
  }
};
